import { connect } from 'react-redux'
import styled from '@emotion/styled'
import { selectIntegrationSettingsForProvider } from 'ducks/integrations'
import { selectCurrentTicketMailboxId } from 'selectors/tickets'

import Card from './Card'

const select = state => {
  const settings = selectIntegrationSettingsForProvider(state, {
    provider: 'salesforce',
  })
  const mailboxId = selectCurrentTicketMailboxId(state)
  const key = `mailboxes.${mailboxId}`

  return {
    settings,
    shouldShowCard: settings[key],
  }
}

const StyledWrapper = styled('div')`
  & .card-content {
    padding: 0;
  }
  & > div {
    border: 0 !important;
  }
  border: 0;
  .sui & .ui.accordion:last-child {
    margin-bottom: 0;
  }
`

const Wrapper = ({ shouldShowCard, ...rest }) => {
  if (!shouldShowCard) return null
  return (
    <StyledWrapper>
      <Card {...rest} />
    </StyledWrapper>
  )
}

export default connect(select, null)(Wrapper)
